import { Route, Routes } from 'react-router-dom'
import { AditionalData } from './aditionaldata/presentation'
import { Checkout } from './checkout/presentation'
import { Homepage } from './homepages/presentation'
import { Offers } from './offers/presentation'

const ROUTES = {
  index: '/',
  offers: '/ofertas',
  checkout: '/checkout',
  aditionalData: '/dados-adicionais',
}

const Router = () => (
  <Routes>
    <Route path={ROUTES.index} element={<Homepage />} />
    <Route path={ROUTES.offers} element={<Offers />} />
    <Route path={ROUTES.checkout} element={<Checkout />} />
    <Route path={ROUTES.aditionalData} element={<AditionalData />} />
    <Route path="*" element={<h1>Not Found</h1>} />
  </Routes>
)

export { Router, ROUTES }
